module.exports = __webpack_public_path__ + "static/media/grin-tongue-squint.55ec3c2c.svg";